import './modules/animations';
import './modules/nav-menu';
import './modules/privacy';
import './modules/share';
import './modules/anchor-scroll';
import './modules/team-slider';
import './modules/toggle-hubs';
import './modules/news-opinions';
import './modules/cookiePolicy';
import './modules/custom-file-upload';
import './modules/newsSearch';